export default defineNuxtPlugin({
	name: "vee-validate",
	order: 1020,
	setup: () => {},
});
